import { Banner, Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { lottiesPaths } from 'Constants/lottiesPaths';
import { openLinkInNewTab } from 'Utils/links';
import { NOT_SUCCESS_LINK } from 'Constants/helpsUrl';
import { TaxScreenType } from 'Types/common';
import * as Styled from '../styles';

const FinishedManualNotSuccess = ({ tax }: TaxScreenType): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const { taxYear, stage } = tax;

  return (
    <FlexContainer direction="column" fullHeight fullWidth gap="dimension_32">
      <Banner
        hasIcon
        label={t(`TaxScreen.${stage}.banner`)}
        mode="default"
        id="pending-banner"
        layout="embed"
      />
      <FlexContainer
        justify="center"
        direction="column"
        align="center"
        gap="dimension_08"
        fullWidth
        fullHeight
      >
        <Text size="L_L_S" color="dark" type="headline">
          {taxYear}
        </Text>
        <Text type="paragraphs" size="L_L_M" color="dark" align="center">
          {t(`TaxScreen.${stage}.title`)}
        </Text>
        <Styled.StyledLottie
          options={{
            path: lottiesPaths.DISCARDED,
            rendererSetting: { progressiveLoad: true },
          }}
        />
        <Text type="paragraphs" color="dark" size="M_L_S" align="center">
          {t(`TaxScreen.${stage}.info`)}
        </Text>
        <Text type="paragraphs" color="dark" size="S_S_S" align="center">
          {t(`TaxScreen.${stage}.subtitle`)}
        </Text>
        <Styled.ButtonsWrapper gap="dimension_16">
          <Buttons.Classic
            label={t(`TaxScreen.${stage}.button`)}
            mode="primary"
            size="m"
            onClick={() => openLinkInNewTab(NOT_SUCCESS_LINK)}
          />
        </Styled.ButtonsWrapper>
      </FlexContainer>
    </FlexContainer>
  );
};

export default FinishedManualNotSuccess;
